import { Directive, DOCUMENT, inject, OnInit, DestroyRef } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ThemeService } from './theme.service';
import { Theme } from './symbols';

@Directive({
  selector: '[appTheme]'
})
export class ThemeDirective implements OnInit {
  #destroyRef = inject(DestroyRef);
  private themeService = inject(ThemeService);
  private documentRef = inject(DOCUMENT);

  ngOnInit() {
    const active = this.themeService.getActiveTheme;
    if (active) {
      this.updateTheme(active);
    }

    this.themeService.themeChange
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((theme: Theme) => this.updateTheme(theme));
  }

  public updateTheme(theme: Theme) {
    // project properties onto the element
    Object.keys(theme.properties).map(key =>
      this.documentRef.body.style.setProperty(key, theme.properties[key])
    );

    // remove old theme
    Object.keys(this.themeService.themes).map(key => {
      if (this.themeService.themes[key].name !== theme.name) {
        return this.documentRef.body.classList.remove(
          `${String(this.themeService.themes[key].name)}-theme`
        );
      }
    });

    // alias element with theme name
    this.documentRef.body.classList.add(`${theme.name}-theme`);
    if (theme?.favicon?.url) {
      this.setFavicon(theme);
    }
  }

  public setFavicon(theme: Theme) {
    const iconLinks =
      this.documentRef.head.querySelectorAll<HTMLLinkElement>(
        'link[rel~="icon"]'
      );
    iconLinks.forEach((link: HTMLLinkElement) => {
      link.href = theme.favicon.url;
      link.removeAttribute('type');
    });
  }
}
